export class SearchPoItemModel {
    page: number = 0;
    limit: number = 0;
    sortType: number;
    sortCol: string;
    culture: string;
    email: string;
    searchPoiItem: string;
    searchCompanyName: string;
    searchSupplierName: string;
    searchPoiUnit: string;
    searchDeliveryProvince: string;
    searchPoCredit: string;
    searchCostCode: string;
    searchDateFrom: string;
    searchDateTo: string;
}
